import * as R from "ramda";
import { SearchFilter } from "./SearchFilter";
import { getCategoryBySlug } from "../../../lib/helpers/category";
import { getColor } from "../../resources/theme";
import {
	getNestedResults,
	parseSearchResults,
} from "../../../lib/helpers/search";
import { getVisibleOffices } from "state/offices/selectors";
import { useHistory, useLocation } from "react-router-dom";
import { useMemo } from "react";
import React, { useEffect, useGlobal, useState } from "reactn";
import SearchBar from "./SearchBar";
import SearchSuggestions from "./SearchSuggestions";
import queryString from "query-string";
import styled from "styled-components";

export const Search = () => {
	const [state] = useGlobal();

	const [search, setSearch] = useState("");
	const [results, setResults] = useState([]);

	const { offices, categories } = state;

	const history = useHistory();
	const location = useLocation();

	const initialCategorySlug = queryString.parse(location.search).category;
	const initialCategory = getCategoryBySlug(categories, initialCategorySlug);
	const [category, setCategory] = useState(initialCategory || {});
	const [tempCategory, setTempCategory] = useState({});
	const [suggestionsOpenable, setSuggestionsOpenable] = useState(true);

	const goToResults = () => history.push(`/search?query=${search}`);

	const officeNames = Object.keys(offices).map((slug) => [
		offices[slug].name,
		offices[slug].category,
		slug,
		offices[slug].distance,
	]);

	const routesToIgnoreSearch = ["/folder"];
	const isInHome =
		location.pathname.includes("/home") ||
		(location.pathname.includes("/") && !!officeNames.length);
	const isInSearchResults =
		!!location.search &&
		location.pathname.includes("search") &&
		!routesToIgnoreSearch.includes(location.search); // guard en caso de que haga match con line folders

	const resetSearch = () => setSearch("");
	const resetCategory = () => setCategory({});
	const resetResults = () => setResults([]);

	const visibleOffices = getVisibleOffices(offices, category.slug);

	const firstSearchResults = useMemo(
		() => parseSearchResults(search, officeNames),
		[search, officeNames]
	);

	const nestedSearchResults = useMemo(
		() => getNestedResults(search, visibleOffices),
		[search, visibleOffices]
	);

	const handleSearch = () => {
		if (!!search && isInHome) {
			setResults(firstSearchResults);
		} else if (!!search && isInSearchResults) {
			setResults(nestedSearchResults);
		}
		!!results.length && setCategoryOnSearch();
	};

	const setCategoryOnSearch = () => {
		const everyResultHasSameCategory = results.every(({ category }) => {
			const name0 = R.pathOr([], ["name"], category);
			const name1 = R.pathOr(null, ["0", "category", "name"], results);
			return name0.includes(name1);
		});
		if (everyResultHasSameCategory) {
			// common category between results
			setTempCategory(results[0].category);
		}
	};

	const showLogs = () => {};

	useEffect(() => {
		handleSearch();
		// showLogs();
		return () => {
			resetCategory();
			// resetResults();
		};
	}, [search, location.pathname, suggestionsOpenable]);

	return (
		<SearchComponent>
			<h3
				style={{
					textAlign: "center",
					fontSize: 35,
					color: "#fff",
					fontWeight: "bold",
				}}
			>
				¿Qué trámite deseas realizar?
			</h3>
			<>
				<SearchContainer className="searchContainer">
					<SearchWrapper>
						<div
							onClick={() => {
								setSuggestionsOpenable(true);
							}}
						>
							<SearchBar
								search={search}
								setSearch={setSearch}
								onSubmit={() => {
									resetResults();
									goToResults();
								}}
							/>
						</div>
						{!!search && !isInSearchResults && (
							<SearchSuggestions
								results={results}
								resetSearch={resetSearch}
								tempCategory={tempCategory}
								suggestionsOpenable={suggestionsOpenable}
								setSuggestionsOpenable={setSuggestionsOpenable}
							></SearchSuggestions>
						)}
					</SearchWrapper>
					{isInSearchResults && <SearchFilter></SearchFilter>}
					{isInSearchResults && !!state.search.resultsQuantity && (
						<ResultsCounter>
							{`${state.search.resultsQuantity} sucursales encontradas`}
						</ResultsCounter>
					)}
				</SearchContainer>
			</>
		</SearchComponent>
	);
};

const SearchComponent = styled.div`
	margin: 48px 48px 8px 48px;
`;

const SearchContainer = styled.div`
	width: 100%;
	margin: 0 auto;
	max-width: 1024px;
`;

const SearchWrapper = styled.div`
	border-radius: 10px;
	box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
`;

const ResultsCounter = styled.h3`
	text-align: center;
	color: ${getColor("bg")};
`;
